<template>
    <div class="season-box__table__row">
        <div class="season-box__table__main">
            <div class="season-box__badge"><span>{{title}}</span></div>
        </div>
        <div class="season-box__table__currency">
            <div :class="['select-wrapper', 'select-wrapper--xs', { 'is-active' : select }]" @click="select = !select">
                <div class="select-trigger"><span class="select-trigger__name">{{currency}}</span><span class="select-trigger__icon">
                    <svg width="1em" height="1em" class="icon icon-chevron ">
                        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                    </svg></span></div>
                <div class="select-body">
                    <div class="select-inner">
                    <div :class="['select-option', {'is-selected' : currency === 'USD'}]" @click="$emit('changeCurrency', { name: name, value: 'USD', index: index })"><span class="select-option__name">USD</span></div>
                    <div :class="['select-option', {'is-selected' : currency === 'TZS'}]" @click="$emit('changeCurrency', { name: name, value: 'TZS', index: index })"><span class="select-option__name">TZS</span></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="season-box__table__price">
            <input type="number" :placeholder="value" v-model="input" @focus="$event.target.parentElement.classList.remove('is-error')" class="form-control form-control-price"/>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['title', 'currency', 'placeholder', 'value', 'name', 'index'],
        data(){
            return {
                select: false,
                input: ''
            }
        },
        mounted(){
            this.input = this.value
            window.addEventListener('click', event => {
                if(!event.target.closest('.select-wrapper')){
                    this.select = false
                } else {
        
                }
                if(event.target.closest('.season-box__table__row')){
                    this.$emit('closeSelects')
                }
            })
            const onClickOutside = e => {
                this.select = this.$el.contains(e.target) && this.select
            };
            document.addEventListener('click', onClickOutside);
            this.$on('hook:beforeDestroy', () => document.removeEventListener('click', onClickOutside));
        },
        watch: {
            input(){
                this.$emit('changeValue', { name: this.name, value: this.input, index: this.index })
            },
            value(){
                this.input = this.value
            }
        },
    }
</script>

